import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function subscribeNewsletter(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/newsletter/subscribe`;
    return _fetch(
      url,
      { withAuth: false },
      {
        method: 'POST',
        body: JSON.stringify({ email: options.email }),
        headers: {
          'Accept': 'application/json;charset=utf-8',
          'Content-Type': 'application/json;charset=utf-8'
        }
      }
    )(context);
  };
}
